<script setup lang="ts">
import { VeeNumericListProps } from '@/components/forms/types.ts';
import Tooltip from '@/components/Tooltip/Tooltip.vue';
import { mdiPlus } from '@mdi/js';
import { useFieldArray } from 'vee-validate';
import { toRef, onMounted } from 'vue';
import VeeTextField from '../TextField/VeeTextField.vue';
import { EMPTY_FIELD_SIGN, useVeeFormProps } from '../utils.ts';
import PtwDeleteButton from '@/components/buttons/PtwDeleteButton.vue';

const props = defineProps<VeeNumericListProps>();

const veeProps = useVeeFormProps(props);

const { fields, push, remove } = useFieldArray(toRef(() => `${props.name}.values`));

onMounted(() => {
  if (fields.value.length === 0) {
    push(undefined);
  }
});
</script>

<template>
  <div>
    <v-list class="text-value-list bg-transparent">
      <v-list-item v-for="(field, index) in fields" :key="field.key" class="pa-0 mb-2">
        <VeeTextField :name="`${name}.values[${index}]`" :mode="veeProps.mode" />

        <template #append>
          <PtwDeleteButton
            v-if="veeProps.mode !== 'details' && fields.length > 1"
            :disabled="!deleteTooltipText"
            size="default"
            @delete="remove(index)"
          />
          <div v-else class="mr-11" />
        </template>
      </v-list-item>
      <!-- no item dash -->
      <p v-if="fields.length === 0 && veeProps.mode === 'details'">
        {{ EMPTY_FIELD_SIGN }}
      </p>
    </v-list>

    <Tooltip :disabled="!addTooltipText">
      <template #target="{ props: tooltipProps }">
        <TextVBtn
          v-if="veeProps.mode !== 'details'"
          v-bind="tooltipProps"
          :disabled="veeProps.disabled"
          size="small"
          class="add-button"
          :icon="mdiPlus"
          variant="outlined"
          aria-label="Add"
          @click="push(undefined)"
        />
      </template>
      <template #tooltip>
        {{ addTooltipText }}
      </template>
    </Tooltip>
  </div>
</template>

<style lang="scss" scoped>
.add-button {
  border: 2px solid;
}
</style>
